import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service"

class BenzoUsageStore {
  @observable highest_benzo_usage = [];
  @observable benzo_usage_physicians = [];
  @observable benzo_usage_by_participant = [];
  @observable benzo_timeline = []
  @observable days_supply = [];
  @observable benzo_count = 0;
  @observable benzo_physicians_count = 0;
  @observable benzo_total_spend = 0;
  ; @observable url = "/api/v1/insightactions/benzo";


  @computed get tiles() {
    return parseInt(this.benzo_count / 100) > 0 ? parseInt(this.benzo_count / 100) + 1 : 0;
  }
  @computed get tiles2() {
    return parseInt(this.benzo_physicians_count / 100) > 0 ? parseInt(this.benzo_physicians_count / 100) + 1 : 0;
  }


  @action getBenzoTotalCost = async data => {
    this.benzo_total_spend = 0;
    try {
      let response = await post(
        `${this.url}/getBenzoTotalCost`,
        data
      );
      this.benzo_total_spend = response.data[0].claim_cost;
    } catch (err) {
      console.log(err);
    }
  };


  @action getHighestBenzoPhysiciansCount = async data => {
    this.benzo_physicians_count = 0;
    try {
      let response = await post(
        `${this.url}/getHighestBenzoPhysiciansCount`,
        data
      );
      this.benzo_physicians_count = response.data[0]?.physician_count;

    } catch (err) {
      console.log(err);
    }
  };

  @action getBenzoTotalCounts = async data => {
    this.benzo_count = 0;
    try {
      let response = await post(
        `${this.url}/getBenzoTotalCounts`,
        data
      );
      if (data.show_by == "Participants") {
        this.benzo_count = response.data.participant_count[0]?.participant_count;
      }
      if (data.show_by == "Drugs") {
        this.benzo_count = response.data.drug_count[0]?.label_count;
      }


    } catch (err) {
      console.log(err);
    }
  };


  @action getBenzoParticipantsCount = async data => {
    this.benzo_participant_count = 0;
    try {
      let response = await post(
        `${this.url}/getBenzoParticipantsCount`,
        data
      );
      this.benzo_participant_count = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  };

  @action getHighestBenzoUsage = async data => {
    this.highest_benzo_usage = [];
    this.benzo_usage_by_participant = [];
    this.benzo_timeline = [];
    this.days_supply = []
    try {
      let response = await post(
        `${this.url}/getHighestBenzoUsage`,
        data
      );

      this.highest_benzo_usage = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getHighestBenzoPhysicians = async data => {
    this.benzo_usage_physicians = [];
    try {
      let response = await post(
        `${this.url}/getHighestBenzoPhysicians`,
        data
      );

      this.benzo_usage_physicians = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getBenzoUsageByParticipant = async data => {
    this.benzo_usage_by_participant = [];
    this.benzo_timeline = [];
    try {
      let response = await post(
        `${this.url}/getBenzoUsageByParticipant`,
        data
      );

      this.benzo_usage_by_participant = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getBenzoUsageTimeLine = async data => {
    this.benzo_timeline = [];
    try {
      let response = await post(
        `${this.url}/getBenzoUsageTimeLine`,
        data
      );

      this.benzo_timeline = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getDaysSupply = async data => {
    this.days_supply = [];
    try {
      let response = await post(
        `${this.url}/getDaysSupply`,
        data
      );

      this.days_supply = response.data;
    } catch (err) {
      console.log(err);
    }
  };
}

export default BenzoUsageStore;
